import React, { Fragment } from "react";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CloseIcon from "@material-ui/icons/Close";
import Modal from "@material-ui/core/Modal";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFilePdf,
  faCalendarCheck,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import moment from "moment";
import ChangeDateSettlement from "./ChangeDateSettlement";

const ReactTableActions = ({
  data,
  dataToPrintPDF,
  getSettlemet,
  dataToExcel,
  deleteRad,
}) => {
  const [modalAddDate, setModalAddDate] = useState(false);

  const radicadoData = data.data.original.data.radicado;
  const radicado = data.data.original;
  const contrato = data.data.original.contrato;

  useEffect(() => {
    console.log("RADICADO", radicado);
  }, []);

  const holdPrintSettlement = () => {
    console.log("Este es un test de impresion de radicado.");
    console.log(radicadoData);
    dataToPrintPDF(
      radicadoData,
      moment(radicado.fecha_inicio).format("DD/MM/YYYY"),
      moment(radicado.fecha_final).format("DD/MM/YYYY"),
      moment(radicado.fecha_radicado).format("DD/MM/YYYY"),
      contrato
    );
  };

  const togglePrintExcel = () => {
    dataToExcel(radicadoData);
  };

  const deleteRadicado = (id_rad) => {
    deleteRad(id_rad);
  };

  return (
    <Fragment>
      <td role="cell">
        <div style={{ display: "flex" }}>
          <div style={{ marginLeft: 5 }}>
            <Tooltip title="PDF Radicado">
              <IconButton
                component="span"
                onClick={(e) => {
                  holdPrintSettlement();
                }}
              >
                <FontAwesomeIcon icon={faFilePdf} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ marginLeft: 5 }}>
            <Tooltip title="Excel Radicado">
              <IconButton
                component="span"
                onClick={(e) => {
                  togglePrintExcel();
                }}
              >
                <FontAwesomeIcon icon={faFileExcel} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ marginLeft: 5 }}>
            <Tooltip title="Fecha Cierre">
              <IconButton
                component="span"
                onClick={(e) => {
                  setModalAddDate(!modalAddDate);
                }}
              >
                <FontAwesomeIcon icon={faCalendarCheck} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ marginLeft: 5 }}>
            <Tooltip title="Eliminar">
              <IconButton
                component="span"
                disabled={
                  radicado.fecha_cierre !== null &&
                  radicado.fecha_cierre !== undefined
                    ? true
                    : false
                }
                onClick={(e) => {
                  deleteRadicado(parseInt(radicado.id_radicado));
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </IconButton>
            </Tooltip>
          </div>
          {modalAddDate ? (
            <ChangeDateSettlement
              modalAddDate={modalAddDate}
              setModalAddDate={setModalAddDate}
              radicado={radicado}
              getSettlemet={getSettlemet}
            />
          ) : null}
        </div>
      </td>
    </Fragment>
  );
};

export default ReactTableActions;